import { Outlet } from "react-router-dom";

const ApprvlLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default ApprvlLayout;
